import { useState, useEffect } from 'react';
import {
    BookOpen,
    Search,
    Filter,
    ChevronDown,
    Calendar,
    Play,
    Download,
    Star,
    Clock,
    Tag,
    Bookmark,
    Share2,
    BookMarked,
    FileText,
    Video,
    AlignLeft,
    User,
    ChevronLeft,
    ChevronRight
} from 'lucide-react';
import { Link } from 'react-router-dom';

const MaterialsPage = () => {
    // Состояния для фильтрации и поиска
    const [searchTerm, setSearchTerm] = useState('');
    const [categoryFilter, setCategoryFilter] = useState('all');
    const [typeFilter, setTypeFilter] = useState('all');
    const [sortBy, setSortBy] = useState('date');
    const [currentView, setCurrentView] = useState('grid'); // 'grid' или 'list'
    const [materials, setMaterials] = useState([]);
    const [filteredMaterials, setFilteredMaterials] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [favoriteItems, setFavoriteItems] = useState([]);
    const [categories, setCategories] = useState([]);
    const [activeCategory, setActiveCategory] = useState(null);

    // Инициализация данных
    useEffect(() => {
        const fetchMaterials = async () => {
            try {
                await new Promise(resolve => setTimeout(resolve, 800)); // Имитация задержки загрузки

                // Моковые данные для категорий
                const mockCategories = [
                    { id: 'business', name: 'Бизнес', icon: 'briefcase', count: 15 },
                    { id: 'marketing', name: 'Маркетинг', icon: 'megaphone', count: 8 },
                    { id: 'personal-growth', name: 'Личностный рост', icon: 'trending-up', count: 12 },
                    { id: 'sales', name: 'Продажи', icon: 'shopping-cart', count: 7 },
                    { id: 'technical', name: 'Технические', icon: 'code', count: 5 },
                    { id: 'leadership', name: 'Лидерство', icon: 'users', count: 9 }
                ];

                // Моковые данные для материалов
                const mockMaterials = [
                    {
                        id: 1,
                        title: 'Основы построения бизнеса в сетевом маркетинге',
                        description: 'Узнайте, как грамотно построить структуру и развить пассивный доход в компании ЛАЙТ.',
                        type: 'video',
                        category: 'business',
                        thumbnail: 'https://placehold.co/600x400/2b6c8e/white?text=Бизнес+в+сетевом+маркетинге',
                        url: 'https://example.com/video1',
                        duration: '1:25:30',
                        createdAt: '2025-05-10T14:30:00',
                        author: 'Максим Иванов',
                        views: 1245,
                        rating: 4.8
                    },
                    {
                        id: 2,
                        title: 'Стратегии интернет-маркетинга для привлечения партнеров',
                        description: 'Практические рекомендации по продвижению в социальных сетях и создания воронки продаж.',
                        type: 'document',
                        category: 'marketing',
                        thumbnail: 'https://placehold.co/600x400/a7d7cd/222222?text=Интернет-маркетинг',
                        url: 'https://example.com/document1',
                        pages: 24,
                        createdAt: '2025-05-08T10:15:00',
                        author: 'Елена Петрова',
                        views: 987,
                        rating: 4.6
                    },
                    {
                        id: 3,
                        title: 'Секреты эффективной коммуникации в бизнесе',
                        description: 'Как правильно выстраивать диалог с потенциальными партнерами и клиентами.',
                        type: 'video',
                        category: 'sales',
                        thumbnail: 'https://placehold.co/600x400/d5ebe6/222222?text=Эффективная+коммуникация',
                        url: 'https://example.com/video2',
                        duration: '48:15',
                        createdAt: '2025-05-05T16:45:00',
                        author: 'Иван Крылов',
                        views: 756,
                        rating: 4.9
                    },
                    {
                        id: 4,
                        title: 'Финансовая свобода: путь к успеху',
                        description: 'Практическое руководство по достижению финансовой независимости в современных условиях.',
                        type: 'document',
                        category: 'personal-growth',
                        thumbnail: 'https://placehold.co/600x400/f0f9f6/222222?text=Финансовая+свобода',
                        url: 'https://example.com/document2',
                        pages: 36,
                        createdAt: '2025-05-03T11:20:00',
                        author: 'Наталья Сергеева',
                        views: 1120,
                        rating: 4.7
                    },
                    {
                        id: 5,
                        title: 'Мастер-класс: Ораторское искусство для бизнеса',
                        description: 'Техники публичных выступлений и проведения презентаций для бизнес-партнеров.',
                        type: 'video',
                        category: 'personal-growth',
                        thumbnail: 'https://placehold.co/600x400/2b6c8e/white?text=Ораторское+искусство',
                        url: 'https://example.com/video3',
                        duration: '1:12:45',
                        createdAt: '2025-04-28T15:10:00',
                        author: 'Алексей Волков',
                        views: 932,
                        rating: 4.8
                    },
                    {
                        id: 6,
                        title: 'Психология продаж в сетевом маркетинге',
                        description: 'Психологические аспекты и техники, которые помогут улучшить результаты в продажах.',
                        type: 'document',
                        category: 'sales',
                        thumbnail: 'https://placehold.co/600x400/a7d7cd/222222?text=Психология+продаж',
                        url: 'https://example.com/document3',
                        pages: 18,
                        createdAt: '2025-04-25T09:30:00',
                        author: 'Ольга Трофимова',
                        views: 845,
                        rating: 4.5
                    },
                    {
                        id: 7,
                        title: 'Лидерство: как вести команду к успеху',
                        description: 'Стратегии и тактики эффективного лидерства в сетевом маркетинге.',
                        type: 'video',
                        category: 'leadership',
                        thumbnail: 'https://placehold.co/600x400/d5ebe6/222222?text=Лидерство',
                        url: 'https://example.com/video4',
                        duration: '54:20',
                        createdAt: '2025-04-20T13:45:00',
                        author: 'Дмитрий Козлов',
                        views: 678,
                        rating: 4.9
                    },
                    {
                        id: 8,
                        title: 'Техническое руководство по использованию платформы ЛАЙТ',
                        description: 'Подробная инструкция по работе с личным кабинетом, кластерами и инструментами системы.',
                        type: 'document',
                        category: 'technical',
                        thumbnail: 'https://placehold.co/600x400/f0f9f6/222222?text=Техническое+руководство',
                        url: 'https://example.com/document4',
                        pages: 42,
                        createdAt: '2025-04-18T10:00:00',
                        author: 'Марина Зайцева',
                        views: 1560,
                        rating: 4.6
                    },
                    {
                        id: 9,
                        title: 'Социальные сети как инструмент привлечения партнеров',
                        description: 'Стратегии развития бизнеса через Facebook, Instagram, ВКонтакте и другие платформы.',
                        type: 'video',
                        category: 'marketing',
                        thumbnail: 'https://placehold.co/600x400/2b6c8e/white?text=Социальные+сети',
                        url: 'https://example.com/video5',
                        duration: '1:05:30',
                        createdAt: '2025-04-15T16:20:00',
                        author: 'Павел Николаев',
                        views: 1230,
                        rating: 4.7
                    },
                    {
                        id: 10,
                        title: 'Построение долгосрочных бизнес-стратегий',
                        description: 'Как планировать развитие бизнеса на годы вперед и достигать стабильного роста.',
                        type: 'document',
                        category: 'business',
                        thumbnail: 'https://placehold.co/600x400/a7d7cd/222222?text=Бизнес-стратегии',
                        url: 'https://example.com/document5',
                        pages: 30,
                        createdAt: '2025-04-10T11:30:00',
                        author: 'Светлана Борисова',
                        views: 890,
                        rating: 4.8
                    },
                    {
                        id: 11,
                        title: 'Искусство ведения переговоров',
                        description: 'Практические навыки ведения переговоров для достижения взаимовыгодных результатов.',
                        type: 'video',
                        category: 'business',
                        thumbnail: 'https://placehold.co/600x400/d5ebe6/222222?text=Ведение+переговоров',
                        url: 'https://example.com/video6',
                        duration: '59:45',
                        createdAt: '2025-04-05T14:15:00',
                        author: 'Антон Медведев',
                        views: 764,
                        rating: 4.5
                    },
                    {
                        id: 12,
                        title: 'Личный бренд в сетевом маркетинге',
                        description: 'Как создать сильный личный бренд и использовать его для привлечения партнеров.',
                        type: 'document',
                        category: 'marketing',
                        thumbnail: 'https://placehold.co/600x400/f0f9f6/222222?text=Личный+бренд',
                        url: 'https://example.com/document6',
                        pages: 22,
                        createdAt: '2025-03-30T09:45:00',
                        author: 'Екатерина Иванова',
                        views: 1340,
                        rating: 4.9
                    }
                ];

                // Добавляем Font Awesome в head документа, если его еще нет
                if (!document.getElementById('font-awesome')) {
                    const link = document.createElement('link');
                    link.id = 'font-awesome';
                    link.rel = 'stylesheet';
                    link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css';
                    document.head.appendChild(link);
                }

                setCategories(mockCategories);
                setMaterials(mockMaterials);
                setFilteredMaterials(mockMaterials);
                setFavoriteItems([1, 3, 7]); // ID избранных материалов

            } catch (error) {
                console.error("Error loading data:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchMaterials();
    }, []);

    // Функция применения фильтров и сортировки
    useEffect(() => {
        if (materials.length === 0) return;

        let filtered = [...materials];

        // Фильтрация по поиску
        if (searchTerm) {
            filtered = filtered.filter(material =>
                material.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                material.description.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        // Фильтрация по категории
        if (categoryFilter !== 'all') {
            filtered = filtered.filter(material => material.category === categoryFilter);
        }

        // Фильтрация по типу
        if (typeFilter !== 'all') {
            filtered = filtered.filter(material => material.type === typeFilter);
        }

        // Сортировка
        switch (sortBy) {
            case 'date':
                filtered.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                break;
            case 'rating':
                filtered.sort((a, b) => b.rating - a.rating);
                break;
            case 'views':
                filtered.sort((a, b) => b.views - a.views);
                break;
            default:
                break;
        }

        setFilteredMaterials(filtered);
    }, [searchTerm, categoryFilter, typeFilter, sortBy, materials]);

    // Переключение избранного статуса
    const toggleFavorite = (id) => {
        setFavoriteItems(prev => {
            if (prev.includes(id)) {
                return prev.filter(itemId => itemId !== id);
            } else {
                return [...prev, id];
            }
        });
    };

    // Установка активной категории
    const handleCategoryClick = (categoryId) => {
        if (categoryId === activeCategory) {
            // Если кликаем на уже активную категорию, снимаем фильтр
            setActiveCategory(null);
            setCategoryFilter('all');
        } else {
            // Иначе устанавливаем новую активную категорию
            setActiveCategory(categoryId);
            setCategoryFilter(categoryId);
        }
    };

    // Форматирование даты
    const formatDate = (dateString) => {
        const options = { day: 'numeric', month: 'long', year: 'numeric' };
        return new Date(dateString).toLocaleDateString('ru-RU', options);
    };

    // Иконка для категории
    const getCategoryIcon = (iconName) => {
        switch (iconName) {
            case 'briefcase': return <i className="fa-solid fa-briefcase"></i>;
            case 'megaphone': return <i className="fa-solid fa-bullhorn"></i>;
            case 'trending-up': return <i className="fa-solid fa-chart-line"></i>;
            case 'shopping-cart': return <i className="fa-solid fa-cart-shopping"></i>;
            case 'code': return <i className="fa-solid fa-code"></i>;
            case 'users': return <i className="fa-solid fa-users"></i>;
            default: return <i className="fa-solid fa-folder"></i>;
        }
    };

    // Получение названия категории по ID
    const getCategoryName = (categoryId) => {
        const category = categories.find(cat => cat.id === categoryId);
        return category ? category.name : 'Общая';
    };

    // Получение компонента для типа материала
    const getTypeIcon = (type) => {
        switch (type) {
            case 'video':
                return <Video size={18} className="mr-2 text-blue-500" />;
            case 'document':
                return <FileText size={18} className="mr-2 text-blue-500" />;
            default:
                return <FileText size={18} className="mr-2 text-blue-500" />;
        }
    };

    return (
        <div className="p-4 md:p-6">
            <h2 className="text-xl md:text-2xl font-bold text-blue-primary mb-4 md:mb-6">Материалы</h2>

            <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
                {/* Боковое меню с категориями */}
                <div className="lg:col-span-1">
                    <div className="bg-white rounded-xl shadow-md overflow-hidden mb-6">
                        <div className="px-4 py-3 border-b">
                            <h3 className="font-semibold text-gray-800 flex items-center">
                                <BookMarked size={18} className="mr-2 text-blue-primary" />
                                Категории
                            </h3>
                        </div>

                        <div className="p-3">
                            <button
                                className={`w-full flex items-center justify-between p-2 rounded-lg text-left mb-2 transition-colors ${
                                    categoryFilter === 'all'
                                        ? 'bg-blue-primary text-white'
                                        : 'text-gray-700 hover:bg-blue-primary/5'
                                }`}
                                onClick={() => {
                                    setCategoryFilter('all');
                                    setActiveCategory(null);
                                }}
                            >
                                <span className="flex items-center">
                                    <i className="fa-solid fa-folder-open mr-2"></i>
                                    <span>Все материалы</span>
                                </span>
                                <span className="text-sm">{materials.length}</span>
                            </button>

                            <div className="space-y-1">
                                {categories.map(category => (
                                    <button
                                        key={category.id}
                                        className={`w-full flex items-center justify-between p-2 rounded-lg text-left transition-colors ${
                                            activeCategory === category.id
                                                ? 'bg-blue-primary text-white'
                                                : 'text-gray-700 hover:bg-blue-primary/5'
                                        }`}
                                        onClick={() => handleCategoryClick(category.id)}
                                    >
                                        <span className="flex items-center">
                                            <span className="w-6 flex justify-center mr-2">
                                                {getCategoryIcon(category.icon)}
                                            </span>
                                            <span>{category.name}</span>
                                        </span>
                                        <span className="text-sm">{category.count}</span>
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="bg-white rounded-xl shadow-md overflow-hidden">
                        <div className="px-4 py-3 border-b">
                            <h3 className="font-semibold text-gray-800 flex items-center">
                                <Bookmark size={18} className="mr-2 text-blue-primary" />
                                Избранное
                            </h3>
                        </div>

                        <div className="p-4">
                            {favoriteItems.length > 0 ? (
                                <div className="space-y-3">
                                    {materials
                                        .filter(material => favoriteItems.includes(material.id))
                                        .map(material => (
                                            <div
                                                key={`fav-${material.id}`}
                                                className="flex items-start p-2 rounded-lg hover:bg-gray-50"
                                            >
                                                <div className="w-12 h-12 rounded-lg bg-blue-primary/10 flex-shrink-0 overflow-hidden mr-3">
                                                    <img
                                                        src={material.thumbnail}
                                                        alt={material.title}
                                                        className="w-full h-full object-cover"
                                                    />
                                                </div>
                                                <div>
                                                    <h4 className="text-sm font-medium text-gray-800 line-clamp-1">{material.title}</h4>
                                                    <p className="text-xs text-gray-500 flex items-center mt-1">
                                                        {material.type === 'video' ? (
                                                            <span className="flex items-center">
                                                                <Clock size={12} className="mr-1" />
                                                                {material.duration}
                                                            </span>
                                                        ) : (
                                                            <span className="flex items-center">
                                                                <AlignLeft size={12} className="mr-1" />
                                                                {material.pages} стр.
                                                            </span>
                                                        )}
                                                    </p>
                                                </div>
                                            </div>
                                        ))}
                                </div>
                            ) : (
                                <div className="text-center py-6">
                                    <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
                                        <Bookmark size={20} className="text-gray-400" />
                                    </div>
                                    <p className="text-gray-500 text-sm">У вас пока нет избранных материалов</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Основной контент */}
                <div className="lg:col-span-3">
                    {/* Фильтры и поиск */}
                    <div className="bg-white rounded-xl shadow-md overflow-hidden mb-6">
                        <div className="p-4">
                            <div className="flex flex-col md:flex-row justify-between space-y-3 md:space-y-0 md:space-x-4">
                                <div className="relative flex-grow max-w-xl">
                                    <input
                                        type="text"
                                        placeholder="Поиск материалов..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-primary/50"
                                    />
                                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
                                </div>

                                <div className="flex flex-wrap md:flex-nowrap gap-2">
                                    {/* Фильтр по типу */}
                                    <div className="relative">
                                        <select
                                            value={typeFilter}
                                            onChange={(e) => setTypeFilter(e.target.value)}
                                            className="appearance-none pl-4 pr-8 py-2 border border-gray-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-primary/50"
                                        >
                                            <option value="all">Все типы</option>
                                            <option value="video">Видео</option>
                                            <option value="document">Документы</option>
                                        </select>
                                        <ChevronDown size={18} className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" />
                                    </div>

                                    {/* Сортировка */}
                                    <div className="relative">
                                        <select
                                            value={sortBy}
                                            onChange={(e) => setSortBy(e.target.value)}
                                            className="appearance-none pl-4 pr-8 py-2 border border-gray-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-primary/50"
                                        >
                                            <option value="date">По дате</option>
                                            <option value="rating">По рейтингу</option>
                                            <option value="views">По просмотрам</option>
                                        </select>
                                        <ChevronDown size={18} className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" />
                                    </div>

                                    {/* Переключатель вида */}
                                    <div className="flex border border-gray-300 rounded-lg overflow-hidden">
                                        <button
                                            type="button"
                                            className={`px-3 py-2 flex items-center ${currentView === 'grid' ? 'bg-blue-primary text-white' : 'bg-white text-gray-700'}`}
                                            onClick={() => setCurrentView('grid')}
                                        >
                                            <i className="fa-solid fa-grid-2 mr-2"></i>
                                            <span className="hidden sm:inline">Сетка</span>
                                        </button>
                                        <button
                                            type="button"
                                            className={`px-3 py-2 flex items-center ${currentView === 'list' ? 'bg-blue-primary text-white' : 'bg-white text-gray-700'}`}
                                            onClick={() => setCurrentView('list')}
                                        >
                                            <i className="fa-solid fa-list mr-2"></i>
                                            <span className="hidden sm:inline">Список</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Результаты поиска */}
                    {isLoading ? (
                        <div className="bg-white rounded-xl shadow-md p-12 flex justify-center">
                            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-primary"></div>
                        </div>
                    ) : filteredMaterials.length === 0 ? (
                        <div className="bg-white rounded-xl shadow-md p-12 text-center">
                            <div className="w-16 h-16 rounded-full bg-gray-100 mx-auto flex items-center justify-center mb-4">
                                <FileText size={28} className="text-gray-400" />
                            </div>
                            <h4 className="text-lg font-medium text-gray-800 mb-2">Материалы не найдены</h4>
                            <p className="text-gray-500 max-w-md mx-auto">
                                Попробуйте изменить параметры поиска или фильтры для получения результатов.
                            </p>
                        </div>
                    ) : (
                        <div className="bg-white rounded-xl shadow-md overflow-hidden">
                            <div className="p-6">
                                {/* Сетка материалов */}
                                {currentView === 'grid' ? (
                                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                                        {filteredMaterials.map(material => (
                                            <div
                                                key={material.id}
                                                className="rounded-xl overflow-hidden border border-gray-200 shadow-sm hover:shadow-md transition-all duration-300 transform hover:-translate-y-1 group"
                                            >
                                                {/* Превью с кнопкой избранного */}
                                                <div className="relative h-40 overflow-hidden">
                                                    <img
                                                        src={material.thumbnail}
                                                        alt={material.title}
                                                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                                                    />
                                                    <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-black/70 to-transparent"></div>
                                                    <button
                                                        className="absolute top-2 right-2 w-8 h-8 bg-white/90 rounded-full flex items-center justify-center transition-colors hover:bg-white"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            toggleFavorite(material.id);
                                                        }}
                                                    >
                                                        {favoriteItems.includes(material.id) ? (
                                                            <i className="fa-solid fa-bookmark text-blue-primary"></i>
                                                        ) : (
                                                            <i className="fa-regular fa-bookmark text-gray-600"></i>
                                                        )}
                                                    </button>

                                                    {/* Тип материала и информация */}
                                                    <div className="absolute bottom-3 left-3 flex items-center">
                                                        <span className="bg-black/60 text-white text-xs px-2 py-1 rounded-full flex items-center">
                                                            {material.type === 'video' ? (
                                                                <>
                                                                    <Play size={12} className="mr-1" />
                                                                    {material.duration}
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <FileText size={12} className="mr-1" />
                                                                    {material.pages} стр.
                                                                </>
                                                            )}
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Контент карточки */}
                                                <div className="p-4">
                                                    <div className="flex items-center justify-between mb-2">
                                                        <span className="text-xs text-blue-primary px-2 py-1 bg-blue-primary/10 rounded-full">
                                                            {getCategoryName(material.category)}
                                                        </span>
                                                        <div className="flex items-center text-amber-500 text-xs">
                                                            <Star size={14} className="mr-1" />
                                                            {material.rating}
                                                        </div>
                                                    </div>

                                                    <h3 className="font-medium text-gray-800 mb-2 line-clamp-2 h-12">{material.title}</h3>

                                                    <p className="text-sm text-gray-600 mb-4 line-clamp-2 h-10">
                                                        {material.description}
                                                    </p>

                                                    <div className="flex justify-between items-center pt-2 border-t border-gray-100">
                                                        <div className="flex items-center text-xs text-gray-500">
                                                            <Calendar size={12} className="mr-1" />
                                                            {formatDate(material.createdAt)}
                                                        </div>

                                                        <a
                                                            href={material.url}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-blue-primary hover:text-blue-primary/80 flex items-center text-sm"
                                                        >
                                                            {material.type === 'video' ? (
                                                                <>
                                                                    <Play size={16} className="mr-1" />
                                                                    Смотреть
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <Download size={16} className="mr-1" />
                                                                    Скачать
                                                                </>
                                                            )}
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    /* Список материалов */
                                    <div className="space-y-4">
                                        {filteredMaterials.map(material => (
                                            <div
                                                key={material.id}
                                                className="flex flex-col md:flex-row border border-gray-200 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all"
                                            >
                                                {/* Превью */}
                                                <div className="relative md:w-48 h-40 md:h-auto overflow-hidden flex-shrink-0">
                                                    <img
                                                        src={material.thumbnail}
                                                        alt={material.title}
                                                        className="w-full h-full object-cover"
                                                    />
                                                    <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-black/70 to-transparent"></div>

                                                    {/* Тип материала */}
                                                    <div className="absolute bottom-3 left-3 flex items-center">
                                                        <span className="bg-black/60 text-white text-xs px-2 py-1 rounded-full flex items-center">
                                                            {material.type === 'video' ? (
                                                                <>
                                                                    <Play size={12} className="mr-1" />
                                                                    {material.duration}
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <FileText size={12} className="mr-1" />
                                                                    {material.pages} стр.
                                                                </>
                                                            )}
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Контент */}
                                                <div className="p-4 flex-grow">
                                                    <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
                                                        <div className="flex items-center space-x-2">
                                                            <span className="text-xs text-blue-primary px-2 py-1 bg-blue-primary/10 rounded-full">
                                                                {getCategoryName(material.category)}
                                                            </span>
                                                            <div className="flex items-center text-amber-500 text-xs">
                                                                <Star size={14} className="mr-1" />
                                                                {material.rating}
                                                            </div>
                                                        </div>

                                                        <button
                                                            className="flex items-center text-xs text-gray-500 hover:text-blue-primary"
                                                            onClick={() => toggleFavorite(material.id)}
                                                        >
                                                            {favoriteItems.includes(material.id) ? (
                                                                <>
                                                                    <i className="fa-solid fa-bookmark mr-1 text-blue-primary"></i>
                                                                    В избранном
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <i className="fa-regular fa-bookmark mr-1"></i>
                                                                    Добавить в избранное
                                                                </>
                                                            )}
                                                        </button>
                                                    </div>

                                                    <h3 className="font-medium text-gray-800 mb-2">{material.title}</h3>

                                                    <p className="text-sm text-gray-600 mb-4">
                                                        {material.description}
                                                    </p>

                                                    <div className="flex flex-wrap items-center justify-between gap-2 pt-2 border-t border-gray-100">
                                                        <div className="flex items-center gap-3 text-xs text-gray-500">
                                                            <div className="flex items-center">
                                                                <Calendar size={12} className="mr-1" />
                                                                {formatDate(material.createdAt)}
                                                            </div>
                                                            <div className="flex items-center">
                                                                <i className="fa-solid fa-eye mr-1"></i>
                                                                {material.views}
                                                            </div>
                                                            <div className="flex items-center">
                                                                <User size={12} className="mr-1" />
                                                                {material.author}
                                                            </div>
                                                        </div>

                                                        <div className="flex items-center gap-2">
                                                            <button className="text-gray-500 hover:text-blue-primary flex items-center text-sm">
                                                                <Share2 size={16} className="mr-1" />
                                                            </button>
                                                            <a
                                                                href={material.url}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="bg-blue-primary text-white py-1 px-4 rounded-full hover:bg-blue-primary/90 transition-colors text-sm flex items-center"
                                                            >
                                                                {material.type === 'video' ? (
                                                                    <>
                                                                        <Play size={16} className="mr-1" />
                                                                        Смотреть
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <Download size={16} className="mr-1" />
                                                                        Скачать
                                                                    </>
                                                                )}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}

                                {/* Пагинация - можно добавить при необходимости */}
                                {filteredMaterials.length > 12 && (
                                    <div className="flex justify-center mt-8">
                                        <nav className="flex items-center space-x-1">
                                            <button className="px-3 py-1 rounded-md border border-gray-300 text-gray-600 hover:bg-gray-50">
                                                <ChevronLeft size={18} />
                                            </button>
                                            <button className="px-3 py-1 rounded-md bg-blue-primary text-white">1</button>
                                            <button className="px-3 py-1 rounded-md border border-gray-300 text-gray-600 hover:bg-gray-50">2</button>
                                            <button className="px-3 py-1 rounded-md border border-gray-300 text-gray-600 hover:bg-gray-50">3</button>
                                            <button className="px-3 py-1 rounded-md border border-gray-300 text-gray-600 hover:bg-gray-50">
                                                <ChevronRight size={18} />
                                            </button>
                                        </nav>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Promotional Banner */}
                    <div className="mt-6 bg-gradient-to-r from-blue-primary to-blue-600 rounded-xl p-6 text-white shadow-lg relative overflow-hidden">
                        <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -mr-32 -mt-32"></div>
                        <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full -ml-24 -mb-24"></div>

                        <div className="relative flex flex-col md:flex-row items-center">
                            <div className="md:w-2/3 mb-6 md:mb-0 md:pr-4">
                                <h3 className="text-xl font-bold mb-2">Хотите стать автором обучающих материалов?</h3>
                                <p className="text-white/80 mb-4">
                                    Поделитесь своим опытом и знаниями с другими партнерами. Лучшие авторы получают дополнительное вознаграждение!
                                </p>
                                <button className="bg-white text-blue-primary font-medium px-6 py-2 rounded-full hover:bg-white/90 transition-colors shadow-md">
                                    Узнать подробнее
                                </button>
                            </div>
                            <div className="md:w-1/3 flex justify-center">
                                <div className="w-32 h-32 bg-white/20 rounded-full flex items-center justify-center">
                                    <i className="fa-solid fa-graduation-cap text-5xl text-white"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MaterialsPage;
